import React, { useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../../../redux/slice/auth-slice";
import theme from "../../../constants/Theme";
import { PanelSkeleton } from "./Profile Skeleton/panelSkeleton";
import { ProfileCardSkeleton } from "./Profile Skeleton/profileCardSkeleton";
import {
  Box,
  Grid,
  Typography,
  Button,
  Stack,
  CircularProgress,
  Snackbar,
  Alert,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
} from "@mui/material";
import UserProfileCard from "../../../components/UserProfileCard";
import CommunityPosts from "../../../components/CommunityPosts";
import ROUTES_PATH from "../../../constants/routes";
import { AddFAQWrapper } from "../../FAQ/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BlockIcon from "@mui/icons-material/Block";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import defaultuser from "../assets/defaultuser.png";
import DashboardLayout from "../../../layout/DashboardLayout/DashboardLayout";
import CommonDialog from "../../../common/commonDialog/CommonDialog";
import UserProfileDialog from "../../../common/userProfileDialog/UserProfileDialog";
import services from "../../../services";
import { messages } from "../../../constants/message/messages";
import axios from "axios";
import { themePalette } from "../../../constants/Theme/colors";

const styles = {
  centeredContent: {
    [theme.breakpoints.up("xl")]: {
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      width: 1,
    },
  },
};

const UserProfile = ({}) => {
  const dispatch = useDispatch();
  const [singleUserData, setSingleUserData] = React.useState({});
  const [errorSnackbar, setErrorSnackBar] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [progressStatus, setProgressStatus] = React.useState(false);
  const [isPanelLoading, setPanelLoading] = React.useState(true);
  const [isCardLoading, setCardLoading] = React.useState(true);
  const userData = useLocation();
  const [successSnackbar, setSuccessSnackbar] = React.useState(false);
  const [saveErrorSnackbar, setSaveErrorSnackbar] = React.useState(false);
  const [saveErrorMsg, setSaveErrorMsg] = React.useState("");

  // Get logged-in user's ID from Redux state
  const loggedInUserInfo = useSelector(state => state?.auth?.userData);
  const loggedInUserId = loggedInUserInfo?.[0]?.["_id"];
  const viewedUserId = userData?.state?.user;
  const isOwnProfile = loggedInUserId === viewedUserId;

  const [editOpen, setEditOpen] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [uploadingPhoto, setUploadingPhoto] = React.useState(false);
  const [editError, setEditError] = React.useState("");
  const [nameErrors, setNameErrors] = React.useState({ firstName: "", lastName: "" });
  const [editForm, setEditForm] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNo: "",
    countryCode: "",
    profileImage: "",
  });
  const [photoFile, setPhotoFile] = React.useState(null);
  const [photoPreview, setPhotoPreview] = React.useState("");

  const [values, setValues] = React.useState({
    reasonText: "",
    error: true,
    isReasonError: false,
    reasonErrorMsg: "",
  });

  const [blockedStatus, setBlockedStatus] = React.useState(
    singleUserData?.blocked
  );



  const editFieldSx = useMemo(
    () => ({
      "& .MuiOutlinedInput-root": {
        background: themePalette.palette.common.white,
      },
      "& .MuiOutlinedInput-root fieldset": {
        border: `2px solid ${themePalette.palette.common.dropdownBorder}`,
      },
      "& .MuiOutlinedInput-root.Mui-focused fieldset": {
        borderColor: themePalette.palette.primary.main,
      },
      "& .MuiOutlinedInput-input": {
        paddingTop: "11px",
        paddingBottom: "11px",
        fontSize: 17,
      },
      "& .MuiInputLabel-root": {
        fontFamily: '"ArchivoMedium", "sans-serif"',
        color: themePalette.palette.text.secondary,
      },
      "& .MuiInputLabel-root.Mui-focused": {
        color: themePalette.palette.primary.main,
      },
    }),
    []
  );

  const handleClickOpen = e => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
    setValues({
      reasonText: "",
      error: true,
      isReasonError: false,
      reasonErrorMsg: "",
    });
  };

  const handleReasonChange = prop => event => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleReasonChangeValue = (prop, value) => {
    setValues({ ...values, [prop]: value });
  };

  const validate = () => {
    let { reasonText } = values;
    if (reasonText.trim() === "") {
      handleReasonChangeValue("isReasonError", true);
      handleReasonChangeValue("reasonErrorMsg", messages.reasonRequired);
      return false;
    } else if (reasonText.trim().length < 3) {
      handleReasonChangeValue("isReasonError", true);
      handleReasonChangeValue("reasonErrorMsg", messages.validReasonRequired);
      return false;
    } else if (reasonText.trim().length > 300) {
      handleReasonChangeValue("isReasonError", true);
      handleReasonChangeValue("reasonErrorMsg", messages.validReasonRequired);
      return false;
    } else {
      return true;
    }
  };

  const handleBlockstatus = () => {
    if (blockedStatus === false) {
      if (validate()) {
        setProgressStatus(true);
        let blockedUser = {
          id: `${userData?.state?.user}`,
          status: !blockedStatus,
          reason: values.reasonText,
        };

        services.changeUserActiveStatus(blockedUser).then(res => {
          if (res.data.statusCode === 200) {
            setBlockedStatus(!blockedStatus);
            setProgressStatus(false);
            setOpen(false);
            setValues(prev => ({ ...prev, reasonText: "" }));
          } else {
            setErrorSnackBar(true);
            setProgressStatus(false);
            setOpen(false);
            setValues(prev => ({ ...prev, reasonText: "" }));
          }
        });
      }
    } else {
      setProgressStatus(true);
      let blockedUser = {
        id: `${userData?.state?.user}`,
        status: !blockedStatus,
      };

      services.changeUserActiveStatus(blockedUser).then(res => {
        if (res.data.statusCode === 200) {
          setBlockedStatus(!blockedStatus);
          setProgressStatus(false);
          setOpen(false);
        } else {
          setErrorSnackBar(true);
          setProgressStatus(false);
          setOpen(false);
        }
      });
    }
  };

  const getSingleUser = async () => {
    const userId = userData?.state?.user;
    setPanelLoading(true);
    setCardLoading(true);
    try {
      const res = await services.singleUser(userId);
      if (res.status === 200) {
        setSingleUserData(res?.data?.data);
        setBlockedStatus(res?.data?.data.blocked);
      }
      return res;
    } finally {
      setPanelLoading(false);
      setCardLoading(false);
    }
  };

  const openEdit = () => {
    setEditError("");
    setPhotoFile(null);
    setPhotoPreview("");
    setEditForm({
      firstName: singleUserData?.firstName || "",
      lastName: singleUserData?.lastName || "",
      email: singleUserData?.email || "",
      mobileNo: singleUserData?.mobileNo || "",
      countryCode: singleUserData?.countryCode || "",
      profileImage: singleUserData?.profileImage || "",
    });
    setEditOpen(true);
  };

  const closeEdit = () => {
    if (saving || uploadingPhoto) return;
    setEditOpen(false);
    setEditError("");
    setPhotoFile(null);
    setPhotoPreview("");
  };

  const onPickPhoto = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const isImage = file.type?.startsWith("image/");
    if (!isImage) {
      setEditError("Please select a valid image file.");
      return;
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      setEditError("Profile photo must be smaller than 5MB.");
      return;
    }
    setEditError("");
    setPhotoFile(file);
    const reader = new FileReader();
    reader.onload = (ev) => setPhotoPreview(String(ev.target?.result || ""));
    reader.readAsDataURL(file);
  };

  const uploadProfilePhotoIfNeeded = async () => {
    if (!photoFile) return editForm.profileImage || "";
    setUploadingPhoto(true);
    try {
      const timestamp = Date.now();
      const safeName = (photoFile.name || "profile.jpg").replace(/\s+/g, "-");
      const s3Key = `users/profile/${viewedUserId}/${timestamp}-${safeName}`;
      const presignedResponse = await services.getS3PresignedUrl(
        s3Key,
        photoFile.type
      );
      const presignedUrl =
        presignedResponse.data?.url ||
        presignedResponse.data?.data?.url ||
        (typeof presignedResponse.data === "string"
          ? presignedResponse.data
          : null);
      if (!presignedUrl || typeof presignedUrl !== "string") {
        throw new Error("Failed to get presigned URL.");
      }

      const s3Axios = axios.create();
      await s3Axios.put(presignedUrl, photoFile, {
        headers: { "Content-Type": photoFile.type },
      });
      return presignedUrl.split("?")[0];
    } finally {
      setUploadingPhoto(false);
    }
  };

  const NAME_REGEX = /^[a-zA-Z\s]*$/;

  const handleNameChange = (field) => (e) => {
    const raw = e.target.value;
    if (raw !== "" && !NAME_REGEX.test(raw)) return;
    const hasLeadingSpace = raw.length > 0 && raw[0] === " ";
    setNameErrors((prev) => ({
      ...prev,
      [field]: hasLeadingSpace ? "Name cannot start with a space" : "",
    }));
    setEditForm((p) => ({ ...p, [field]: raw }));
  };

  const handleSaveProfile = async () => {
    setEditError("");
    setSaveErrorMsg("");

    const firstNameTrimmed = (editForm.firstName || "").trim();
    const lastNameTrimmed = (editForm.lastName || "").trim();
    const newNameErrors = {
      firstName: !firstNameTrimmed ? "First name is required" : "",
      lastName: !lastNameTrimmed ? "Last name is required" : "",
    };
    setNameErrors(newNameErrors);
    if (newNameErrors.firstName || newNameErrors.lastName) return;

    setSaving(true);
    try {
      const profileImageUrl = await uploadProfilePhotoIfNeeded();

      const cleanedMobileNo = (editForm.mobileNo || "").replace(/\s+/g, "").trim();
      const cleanedCountryCode = (editForm.countryCode || "").trim();

      const payload = {
        // Different backends use different identifiers; include all common keys.
        id: viewedUserId,
        _id: viewedUserId,
        userId: viewedUserId,
        profileImage: profileImageUrl || undefined,
        firstName: editForm.firstName?.trim(),
        lastName: editForm.lastName?.trim(),
        email: editForm.email?.trim(),
        mobileNo: cleanedMobileNo,
        countryCode: cleanedCountryCode,
      };



      Object.keys(payload).forEach((k) => {
        if (payload[k] === "" || payload[k] === undefined) delete payload[k];
      });

      const res = await services.updateUser(payload);
      const apiCode =
        typeof res?.data?.code === "number"
          ? res.data.code
          : typeof res?.data?.statusCode === "number"
            ? res.data.statusCode
            : typeof res?.status === "number"
              ? res.status
              : 0;
      const ok = apiCode >= 200 && apiCode <= 299;
      if (!ok) {
        throw new Error(
          res?.data?.message ||
            res?.data?.error ||
            `Update failed (code ${apiCode}).`
        );
      }

      setEditOpen(false);
      setSuccessSnackbar(true);

      // If the admin is editing their own profile, sync the Redux auth state
      // so the top-right header name updates immediately without a page reload.
      if (isOwnProfile) {
        dispatch(
          authActions.updateUserData({
            fullName: `${editForm.firstName?.trim()} ${editForm.lastName?.trim()}`.trim(),
          })
        );
      }

      // Optimistic UI update so the profile view updates immediately
      setSingleUserData(prev => ({
        ...prev,
        firstName: editForm.firstName?.trim() || prev?.firstName,
        lastName: editForm.lastName?.trim() || prev?.lastName,
        email: editForm.email?.trim() || prev?.email,
        mobileNo: cleanedMobileNo || prev?.mobileNo,
        countryCode: cleanedCountryCode || prev?.countryCode,
        profileImage: profileImageUrl || prev?.profileImage,
      }));
      // Then refetch to ensure the UI matches server state
      await getSingleUser();
    } catch (e) {
      const msg =
        e?.response?.data?.message ||
        e?.response?.data?.error ||
        e?.message ||
        "Update failed.";
      setEditError(msg);
      setSaveErrorMsg(msg);
      setSaveErrorSnackbar(true);
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    getSingleUser();
  }, []);

  return (
    <DashboardLayout>
      <Box
        sx={{
          p: 1,
          pt: { xl: 0, lg: 0, md: 0, sm: 0, xs: 2 },
        }}
      >
        {isPanelLoading ? (
          <PanelSkeleton />
        ) : (
          <Grid container>
            <Grid item xl={9} lg={9} md={6} sm={6} xs={8}>
              <Link to={ROUTES_PATH.DASHBOARD + "/users"}>
                <ArrowBackIcon
                  sx={{
                    fontSize: 30,
                    position: "relative",
                    top: "5px",
                    color: "green",
                  }}
                />
              </Link>
              <Typography
                variant="heading2"
                sx={{
                  mb: 1,
                  ml: 3,
                }}
              >
                {singleUserData?.firstName + " " + singleUserData?.lastName}
              </Typography>
            </Grid>

            <Grid item xl={3} lg={3} md={6} sm={6} xs={4}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ py: 3, width: "140px", fontSize: 18 }}
                  onClick={openEdit}
                >
                  Edit Profile
                </Button>

                {!isOwnProfile && (
                  <Button
                    variant="outlined"
                    color="error"
                    sx={{ py: 3, width: "120px", fontSize: 18 }}
                    onClick={handleClickOpen}
                  >
                    {!blockedStatus ? "Block" : "Unblock"}
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        )}

        <Stack>
          <Box
            sx={{
              [theme.breakpoints.up("xl")]: {
                maxWidth: theme.breakpoints.values.lg,
              },
              m: "0 auto",
              width: "100%",
            }}
          >
            <Grid container spacing={3}>
              <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
                <Grid container spacing={3}>
                  {isCardLoading ? (
                    <ProfileCardSkeleton />
                  ) : (
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <UserProfileCard
                        profileImg={singleUserData?.profileImage || defaultuser}
                        fullName={
                          singleUserData?.firstName +
                          " " +
                          singleUserData?.lastName
                        }
                        contact={
                          singleUserData?.mobileNo 
                        }
                        email={
                          singleUserData?.email
                        }
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>

              <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                <CommunityPosts />
              </Grid>
            </Grid>
          </Box>
        </Stack>
      </Box>

      <CommonDialog
        open={open}
        title={!blockedStatus ? "Block User" : "Unblock User"}
        subtext={
          !blockedStatus
            ? "Are you sure you want to block the user?"
            : "Are you sure you want to unblock the user?"
        }
        reasonTitle={
          !blockedStatus && (
            <TextField
              id="outlined-multiline-static"
              label="Reason"
              multiline
              rows={2}
              inputProps={{ maxLength: 300 }}
              sx={{
                mt: 3,
                width: 1,

                "& .MuiFormHelperText-root": {
                  textAlign: values.reasonErrorMsg ? "left" : "right",
                  color: values.reasonErrorMsg
                    ? theme => theme.palette.error.main
                    : theme => theme.palette.text.secondary,
                },
              }}
              value={values.reasonText}
              onFocus={() => {
                handleReasonChangeValue("isReasonError", false);
                handleReasonChangeValue("reasonErrorMsg", "");
              }}
              onChange={handleReasonChange("reasonText")}
              error={values.isReasonError}
              helperText={
                values.reasonErrorMsg
                  ? values.reasonErrorMsg
                  : `${values.reasonText.length}/300`
              }
            />
          )
        }
        iconSpacing={"24px"}
        dialogSize={"xs"}
        dialogIcon={
          <BlockIcon
            sx={{
              fontSize: 28,
              color: theme => theme.palette.primary.main,
              opacity: 0.8,
            }}
          />
        }
        dialogAction={
          <React.Fragment>
            <Button
              variant="outlined"
              disabled={progressStatus}
              sx={{
                border: `1px solid ${theme => theme.palette.primary.main}`,
                background: theme => theme.palette.common.white,
                fontSize: 18,
                py: 3,
                mr: 3,
              }}
              onClick={handleClickClose}
            >
              No
            </Button>

            <Button
              onClick={() => handleBlockstatus()}
              variant="contained"
              sx={{ fontSize: 18, py: 3 }}
            >
              {progressStatus ? (
                <>
                  <CircularProgress
                    size="1rem"
                    color="inherit"
                    style={{ marginRight: "5px" }}
                  />{" "}
                  Yes
                </>
              ) : (
                "Yes"
              )}
            </Button>
          </React.Fragment>
        }
      />

      <Snackbar
        open={errorSnackbar}
        autoHideDuration={4000}
        onClose={() => setErrorSnackBar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setErrorSnackBar(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {messages.somethingWentWrong}
        </Alert>
      </Snackbar>

      <Snackbar
        open={successSnackbar}
        autoHideDuration={3000}
        onClose={() => setSuccessSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSuccessSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Profile updated successfully.
        </Alert>
      </Snackbar>

      <Snackbar
        open={saveErrorSnackbar}
        autoHideDuration={4000}
        onClose={() => setSaveErrorSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSaveErrorSnackbar(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {saveErrorMsg || messages.somethingWentWrong}
        </Alert>
      </Snackbar>

      <UserProfileDialog
        open={editOpen}
        close={closeEdit}
        title={"Edit Profile"}
        dialogSize={"sm"}
        dialogContent={
          <Box sx={{ pt: 2 }}>
            <Stack spacing={3}>
              {editError ? (
                <Alert severity="error" onClose={() => setEditError("")}>
                  {editError}
                </Alert>
              ) : null}

              <Box
                sx={{
                  background: theme => theme.palette.common.tabTableBackground,
                  borderRadius: "12px",
                  border: `1px solid ${themePalette.palette.common.headerDivider}`,
                  p: 3,
                }}
              >
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  alignItems={{ xs: "flex-start", sm: "center" }}
                  justifyContent="space-between"
                >
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Avatar
                      src={
                        photoPreview ||
                        editForm.profileImage ||
                        singleUserData?.profileImage ||
                        defaultuser
                      }
                      sx={{
                        width: 72,
                        height: 72,
                        border: `2px solid ${themePalette.palette.common.white}`,
                      }}
                    />
                    <Box>
                    <Typography
                      variant="titleLarge"
                      sx={{ color: themePalette.palette.primary.main }}
                    >
                        {singleUserData?.firstName
                          ? `${singleUserData?.firstName} ${singleUserData?.lastName || ""}`
                          : "User"}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: themePalette.palette.text.secondary,
                          mt: 0.5,
                        }}
                      >
                        Update profile photo and contact details
                      </Typography>
                    </Box>
                  </Stack>

                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    sx={{ width: { xs: 1, sm: "auto" } }}
                  >
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<PhotoCameraIcon />}
                      disabled={saving || uploadingPhoto}
                      sx={{
                        py: 2,
                        fontSize: 16,
                        width: { xs: 1, sm: "auto" },
                        color: themePalette.palette.primary.main,
                        borderColor: themePalette.palette.primary.main,
                        "&:hover": {
                          borderColor: themePalette.palette.primary.main,
                          backgroundColor: themePalette.palette.primary.main,
                          color: themePalette.palette.common.white,
                          "& .MuiButton-startIcon": {
                            color: themePalette.palette.common.white,
                          },
                        },
                      }}
                    >
                      Upload photo
                      <input
                        hidden
                        type="file"
                        accept="image/*"
                        onChange={onPickPhoto}
                      />
                    </Button>
                    {uploadingPhoto ? (
                      <Stack direction="row" spacing={1} alignItems="center">
                        <CircularProgress size="1rem" />
                        <Typography variant="body2">Uploading…</Typography>
                      </Stack>
                    ) : null}
                  </Stack>
                </Stack>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="First name"
                    placeholder="Enter first name"
                    value={editForm.firstName}
                    onChange={handleNameChange("firstName")}
                    fullWidth
                    size="small"
                    error={!!nameErrors.firstName}
                    helperText={nameErrors.firstName}
                    InputLabelProps={{ shrink: true }}
                    sx={editFieldSx}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Last name"
                    placeholder="Enter last name"
                    value={editForm.lastName}
                    onChange={handleNameChange("lastName")}
                    fullWidth
                    size="small"
                    error={!!nameErrors.lastName}
                    helperText={nameErrors.lastName}
                    InputLabelProps={{ shrink: true }}
                    sx={editFieldSx}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Email"
                    type="email"
                    placeholder="Enter email"
                    value={editForm.email}
                    fullWidth
                    disabled
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    sx={editFieldSx}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Country code"
                    placeholder="+91"
                    value={editForm.countryCode}
                    onChange={(e) =>
                      setEditForm((p) => ({ ...p, countryCode: e.target.value }))
                    }
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    sx={editFieldSx}
                  />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    label="Mobile number"
                    placeholder="Enter mobile number"
                    value={editForm.mobileNo}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                      setEditForm((p) => ({ ...p, mobileNo: val }));
                    }}
                    fullWidth
                    size="small"
                    inputProps={{ maxLength: 10, inputMode: "numeric" }}
                    InputLabelProps={{ shrink: true }}
                    sx={editFieldSx}
                  />
                </Grid>
              </Grid>

              <Box
                sx={{
                  backgroundColor: theme =>
                    `${theme.palette.common.dialogActions} !important`,
                  borderRadius: "12px",
                  p: 2.5,
                  display: "flex",
                  gap: 2,
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={closeEdit}
                  disabled={saving || uploadingPhoto}
                  sx={{ fontSize: 18, py: 2.2, px: 4 }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSaveProfile}
                  disabled={saving || uploadingPhoto}
                  sx={{ fontSize: 18, py: 2.2, px: 4 }}
                >
                  {saving ? (
                    <>
                      <CircularProgress
                        size="1rem"
                        color="inherit"
                        style={{ marginRight: "8px" }}
                      />
                      Save
                    </>
                  ) : (
                    "Save"
                  )}
                </Button>
              </Box>
            </Stack>
          </Box>
        }
      />
    </DashboardLayout>
  );
};

export default UserProfile;
